const localStorageKeys = {
  globalComponentsContext: 'lkp_cmts_ctx',
  headerFiltersContext: 'lkp_hf_ctx',
  authContext: 'lkp_auth_ctx',
  permissionContext: 'lkp_permission_ctx',
};

// Chaves de controle do fluxo de atualização de versão.
// Reescritas após o reset — NUNCA zeradas (limpar reabre o loop de reset).
const APP_VERSION_KEY = 'app-version';
const FORCE_RESET_KEY = 'force-reset-v1';

// sessionStorage: versões para as quais um reset já rodou NESTA sessão.
// Cinto once-per-session-per-version — impede loop de modal quando o HTML vier
// de cache stale (a meta é hash de commit, não-ordenável). Some ao fechar a aba.
const VERSION_RESET_SESSION_KEY = 'lkp_version_reset';

// --- Allowlists do reset de dados locais (fonte única) ---
// A limpeza é "preserve-allowlist": tudo que NÃO estiver preservado é removido.
// Assim, cache novo criado no futuro é limpo automaticamente, sem precisar
// manter uma denylist em dia (que silenciosamente deixaria cache stale acumular).

// localStorage a PRESERVAR: o login depende de authContext/permissionContext; e
// headerFiltersContext (lkp_hf_ctx) guarda o contexto de navegação (empresa, unidades,
// estado, cidade, fornecedor, grupos, systems, teams) — dados de entidade, não cache de UI.
// Preserva o filtro `systems` (que não tem cookie) e reconcilia nomes no reload.
const PRESERVE_LS = [
  localStorageKeys.authContext,
  localStorageKeys.permissionContext,
  localStorageKeys.headerFiltersContext,
];

// localStorage de CONTROLE: preservado durante a limpeza e reescrito logo em seguida
// (app-version = versão nova, force-reset atualizado). Nunca some.
const CONTROL_LS = [APP_VERSION_KEY, FORCE_RESET_KEY];

// Cookies a PRESERVAR: o front grava authToken/refreshToken e o refresh 401 depende deles.
// signIn:session é legado (lido só pelo SessionManager, sem consumidor vivo) — mantido por segurança.
const PRESERVE_COOKIES = ['authToken', 'refreshToken', 'signIn:session'];

// Cookies dos filtros globais do header (contexto de navegação). São a fonte PRIMÁRIA
// reconstruída no reload (GlobalFiltersContext/HeaderFilters leem daqui); se sumirem, o
// filtro vira `false` mesmo com lkp_hf_ctx preservado. Enumerados (não têm prefixo comum);
// espelham removeHeaderFilterCookies/useCookies. `teams` incluído por completude (sem UI hoje).
const PRESERVE_FILTER_COOKIES = [
  'companies',
  'unitGroups',
  'unitSubgroups',
  'units',
  'states',
  'cities',
  'teams',
  'providers',
];

export {
  localStorageKeys,
  APP_VERSION_KEY,
  FORCE_RESET_KEY,
  VERSION_RESET_SESSION_KEY,
  PRESERVE_LS,
  CONTROL_LS,
  PRESERVE_COOKIES,
  PRESERVE_FILTER_COOKIES,
};
